import {
  ADD_PAYMENT_METHOD_REQUEST,
  ADD_PAYMENT_METHOD_SUCCESS,
  ADD_PAYMENT_METHOD_ERROR,
  FINISH_VERIFICATION_REQUEST,
  FINISH_VERIFICATION_SUCCESS,
  FINISH_VERIFICATION_ERROR,
  HIDE_PAYMENTS_ERROR,
  SHOW_PAYMENTS_ERROR,
  RESET_PAYMENTS,
} from '../actions/payments';

export const initialState = null;

export default function paymentsErrorReducer(state = initialState, action) {
  switch (action.type) {
    case ADD_PAYMENT_METHOD_ERROR:
    case FINISH_VERIFICATION_ERROR:
    case SHOW_PAYMENTS_ERROR:
      return action.error;
    case ADD_PAYMENT_METHOD_REQUEST:
    case ADD_PAYMENT_METHOD_SUCCESS:
    case FINISH_VERIFICATION_REQUEST:
    case FINISH_VERIFICATION_SUCCESS:
    case HIDE_PAYMENTS_ERROR:
    case RESET_PAYMENTS:
      return initialState;
    default:
      return state;
  }
}
